import { createCustomError } from '@lib/errors';
import { i18n } from '@lib/i18n';

import { LapEntity } from '@modules/lap/entities';
import { LapAccessTarget } from '@modules/types/graphql';

import type { RegionEntity, LocationEntity } from '@modules/shared/entities';
import type { LapAccessEntity } from '@modules/lap/entities';
import type { SchoolEntity } from '@modules/schools/entities';
import type { LapAccessCreateArgs } from '@modules/types/graphql';

export type AttachSchoolFormValues = {
    region: RegionEntity | null;
    location: LocationEntity | null;
    school: SchoolEntity | null;
    neededCopyFromLap: boolean;
    fromLap: LapAccessEntity | null;
};

export type AttachSchoolExtra = {
    lap: LapEntity;
};

class AttachSchoolRequest {
    target: LapAccessCreateArgs['target'];
    targetId: LapAccessCreateArgs['targetId'];
    lapId: LapAccessCreateArgs['lapId'];
    fromLapId: LapAccessCreateArgs['fromLapId'];

    constructor(values: AttachSchoolFormValues, extra: AttachSchoolExtra) {
        if (!values.location) {
            throw createCustomError(i18n.t('errors:location.invalid'));
        }

        if (!values.school) {
            throw createCustomError(i18n.t('errors:school.invalid'));
        }

        this.target = LapAccessTarget.school;
        this.targetId = values.school.id;
        this.lapId = extra.lap?.id;
        this.fromLapId = values.fromLap?.lap?.id;
    }
}

export { AttachSchoolRequest };
